import { Household } from "@/types/types";
import React from "react";
import { HouseholdSkeleton } from "./HouseholdSkeletons";

type HouseholdInfoProps = {
  isLoading: boolean;
  isRefetching: boolean;
  household: Partial<Household> | undefined;
};

const HouseholdInfo: React.FC<HouseholdInfoProps> = ({ isLoading, isRefetching, household }) => {
  return (
    <div className="flex flex-1 flex-col gap-4">
      {isLoading || isRefetching ? (
        <HouseholdSkeleton />
      ) : (
        <>
          <h2 className="text-lg font-medium">Household</h2>
          <div
            className={`flex flex-wrap justify-between gap-6 rounded-md bg-white p-6 shadow-light`}
          >
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Name</span>
              <span>{household?.name}</span>
            </div>
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Client Code</span>
              <span>{household?.clientCode}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HouseholdInfo;
